import { setAutosaveCallback } from "@/stores/dataflow";
import type { UseWorkspaceAutosaveOptions } from "@/types/hooks";
import { useEffect, useRef } from "react";
import { useAutoSave } from "../data/useAutoSave";

/**
 * Hook to set up autosave for a workspace
 * Registers the autosave callback with the dataflow store
 */
export function useWorkspaceAutosave({
  dataflowId,
  projectId,
}: UseWorkspaceAutosaveOptions) {
  const { triggerAutoSave } = useAutoSave({
    dataflowId,
    projectId,
  });

  const triggerAutoSaveRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    triggerAutoSaveRef.current = triggerAutoSave;
    setAutosaveCallback(() => {
      triggerAutoSaveRef.current?.();
    });

    return () => {
      setAutosaveCallback(() => {});
    };
  }, [triggerAutoSave]);
}
